export default __webpack_public_path__ + "static/media/banners_1.e9aa84d5.png";